import React from 'react';
import { useCalendarRealtime } from '../../hooks/useCalendarRealtime';

/**
 * AB#1753 — Calendar v1 C7 realtime bridge.
 *
 * Render-null component that exists solely to invoke
 * <see cref="useCalendarRealtime"/> at the App.tsx level. Drop it into
 * the authenticated route shell ONCE — the underlying hook is singleton-
 * guarded so a duplicate mount is harmless, but it's still cleanest to
 * place a single instance high in the tree.
 *
 * No props, no UI — the hook owns the SignalR lifecycle and the cache
 * invalidation. The toast is dispatched via ToastContext from inside
 * the hook.
 */
const CalendarRealtimeBridge: React.FC = () => {
    useCalendarRealtime();
    return null;
};

export default CalendarRealtimeBridge;
